function selectCustom() {
	const placeholderDefault = 'Seleccione una opción...';
	const selects = jQuery('[data-select-custom="select"]');

	jQuery.each(selects, function () {
		let select = jQuery(this);
		let data = {
			fath: select.find('.select'),
			input: select.find('input[type="hidden"]'),
			select: select.find('.select__content'),
			placeholder: select.find('.select__placeholder'),
			options: select.find('.select__option')
		};

		renderSelectCustom(data);
		
		/**
		 * Open Select With Input
		 */
		data.placeholder.on('click', function () {
			openSelect(data);
		});

		
		/**
		 * Close Select Click Outzone
		 */
		jQuery(document).click(function (e) {
			if (!select.is(e.target) && select.has(e.target).length === 0) {
				closeSelect(data);
			}
		});


		/**
		 * Option Event
		 */
		jQuery.each(data.options, function () {
			let option = jQuery(this);
			option.on('click', function () {
				let value = (option.attr('data-value') != undefined) ? option.attr('data-value') : '';
				setValue(data, value);
				renderSelectCustom(data);
				closeSelect(data);
			});
		});
	});


	/**
	 * Render Status Select
	 * @param {object} data 
	 */
	function renderSelectCustom(data) {
		let value = data.input.val();
		let selected = data.options.filter(`[data-value="${value}"]`).first();
		let placeholder = (selected.length > 0) ? selected.text() : placeholderDefault;

		data.options.removeClass('is--active');
		selected.addClass('is--active');
		data.placeholder.text(placeholder);
	}


	/**
	 * Open Options
	 * @param {object} data 
	 */
	function openSelect(data) {
		data.fath.addClass('is--focus');
		data.select.addClass('is--open');
	}


	/**
	 * Close Options
	 * @param {object} data 
	 */
	function closeSelect(data) {
		data.fath.removeClass('is--focus');
		data.select.removeClass('is--open');
	}


	/**
	 * Set Input Value
	 * @param {object} data 
	 * @param {*} value 
	 */
	function setValue(data, value) {
		data.input.val(value);
	}
}